export interface IAlertRelativeTimeOption {
  conditionTimeframe: number;
  relativeTimeframe: number;
}

export function eq(x: IAlertRelativeTimeOption, y: IAlertRelativeTimeOption): boolean {
  return x.conditionTimeframe === y.conditionTimeframe &&
    x.relativeTimeframe === y.relativeTimeframe;
}
